'use client';

import {type ReactNode} from 'react';

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/foundation/components/accordion';

type Props = {
	question: string;
	children: ReactNode;
};

export const FaqItem = ({question, children}: Props) => {
	return (
		<Accordion type="single" collapsible>
			<AccordionItem value="faq" className="border-none">
				<AccordionTrigger className="p-0">{question}</AccordionTrigger>
				<AccordionContent className="mt-3">{children}</AccordionContent>
			</AccordionItem>
		</Accordion>
	);
};
